export default "__VITE_ASSET__Bz6z1Fo2__"